import { render } from "./HandbookDashboard.vue?vue&type=template&id=41353d15&scoped=true"
import script from "./HandbookDashboard.vue?vue&type=script&lang=js"
export * from "./HandbookDashboard.vue?vue&type=script&lang=js"

import "./HandbookDashboard.vue?vue&type=style&index=0&id=41353d15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41353d15"]])

export default __exports__